/**
 * Capitalizes the first letter of a string.
 * @param {string} string - The string to capitalize
 * @returns {string}
 */
export const capitalizeFirstLetter = (string) => {
  if (!string) return '';
  return string.charAt(0).toUpperCase() + string.slice(1);
};

/**
 * Truncates a filename if it exceeds maxLength, preserving the extension.
 * @param {string} name - The file name
 * @param {number} maxLength - Maximum length (default 30)
 * @returns {string}
 */
export const truncateFileName = (name, maxLength = 30) => {
  if (!name || name.length <= maxLength) return name;
  const lastDot = name.lastIndexOf('.');
  if (lastDot === -1) {
    return name.substring(0, maxLength - 3) + '...';
  }
  const ext = name.substring(lastDot);
  const baseName = name.substring(0, lastDot);
  const availableLength = maxLength - ext.length - 3;
  if (availableLength <= 0) {
    return name.substring(0, maxLength - 3) + '...';
  }
  return baseName.substring(0, availableLength) + '...' + ext;
};

/**
 * Renders a scalar or array value as a displayable string.
 * Handles repeater field arrays (objects with `value` property).
 * @param {*} value - The value to render
 * @returns {string}
 */
export const renderDisplayValue = (value) => {
  if (value === null || value === undefined) {
    return '-';
  }
  if (Array.isArray(value)) {
    if (value.length === 0) return '-';
    // Check if this is a repeater array (objects with 'value' property)
    const isRepeaterArray = value.every(
      (item) => item && typeof item === 'object' && 'value' in item
    );
    if (isRepeaterArray) {
      return value.map((item) => item.value || '-').join(', ');
    }
    // Regular array - convert each item to string safely
    return (
      value
        .map((item) => {
          if (item === null || item === undefined) return '-';
          if (typeof item === 'object') return JSON.stringify(item);
          return String(item);
        })
        .join(', ') || '-'
    );
  }
  if (typeof value === 'object') {
    return JSON.stringify(value);
  }
  return String(value);
};
